import { Fragment, type ReactNode } from 'react';
import type { Les } from '../types';

/** '3' of, bij een blokuur, '3–4'. Leeg bij een activiteit zonder lesuur. */
export function uurNummer(uur: number | null, uurTot: number | null): string {
  if (!uur) return '';
  return uurTot && uurTot > uur ? `${uur}–${uurTot}` : `${uur}`;
}

/** 'uur 3' of 'uur 3–4': de voorleestekst bij het bolletje. */
export function uurLabel(uur: number | null, uurTot: number | null): string {
  const nummer = uurNummer(uur, uurTot);
  return nummer ? `uur ${nummer}` : '';
}

export function MetaRegel({ les }: { les: Les }) {
  const docentWijziging = les.wijzigingen.find((w) => w.veld === 'docent');
  const uurWijziging = les.wijzigingen.find((w) => w.veld === 'uur');

  // Delen die met een punt worden gescheiden.
  const delen: ReactNode[] = [];

  if (les.docenten.length > 0) delen.push(les.docenten.join(', '));

  if (docentWijziging) {
    delen.push(
      <>
        {'was '}
        <span className="old-val">{docentWijziging.oud}</span>
      </>,
    );
  }

  if (uurWijziging) delen.push(`verplaatst van ${uurWijziging.oud}`);

  // De staarttekst: bij uitval de reden, anders de opmerking bij de les (bijv.
  // "SO hoofdstuk 4"), en anders de toelichting van Zermelo — maar die laatste
  // alleen als er geen concrete wijziging is, want dan staat hetzelfde er al.
  const staart = les.status === 'cancelled'
    ? les.toelichting || 'vervalt'
    : les.opmerking || (les.wijzigingen.length === 0 ? les.toelichting : '');

  if (staart) delen.push(staart);

  return (
    <div className="meta">
      {delen.map((deel, i) => (
        <Fragment key={i}>
          {i > 0 && <span> · </span>}
          {deel}
        </Fragment>
      ))}
    </div>
  );
}
